/** Between “Create account” and “Log in” in the marketing header (visual separator only). */
export const LANDING_SITE_NAV_AUTH_SEPARATOR = '·' as const

import { PUBLIC_SIGN_IN_PATH } from '../../signIn/constants/publicAuthRoutes.constants'

/** In-app and marketing URLs used by the landing site header (single source of truth). */
export const LANDING_SITE_NAV_ROUTES = {
  HOME: '/',
  ORGANIZATIONS: '/organizations',
  CONTACT: '/contact',
  PACKS: '/packs',
  SIGN_IN: PUBLIC_SIGN_IN_PATH,
  APP: '/app/',
} as const

/** Scroll in-page targets up so section titles clear the sticky nav (web). */
export const LANDING_SITE_NAV_SCROLL_OFFSET_PX = 64

/** Legacy `/?section=contact` or `/?section=features` from older nav links. */
export const LANDING_PAGE_LEGACY_SECTION_PARAM = 'section' as const
export const LANDING_PAGE_LEGACY_SECTION_CONTACT = 'contact' as const
export const LANDING_PAGE_LEGACY_SECTION_FEATURES = 'features' as const
/** Deep-link to marketing pricing block on `/` (avoids routing to `/packs`). */
export const LANDING_PAGE_LEGACY_SECTION_PRICING = 'pricing' as const

/** Public home with `section=pricing` — handled in `app/index.tsx` to scroll after navigation. */
export const LANDING_MARKETING_HOME_PRICING_HREF =
  `/?${LANDING_PAGE_LEGACY_SECTION_PARAM}=${LANDING_PAGE_LEGACY_SECTION_PRICING}` as const

/** Between “Log in” and “Create account” in the site header (single visual group). */
export const LANDING_SITE_NAV_AUTH_LINKS_SEPARATOR = '·' as const

export const LANDING_SITE_NAV_SIGN_OUT_ICON = {
  SIZE: 20,
  COLOR: 'rgba(255, 255, 255, 0.88)',
} as const

/** Dense org bar (narrow web): smaller hit target, less visual weight. */
export const LANDING_SITE_NAV_SIGN_OUT_ICON_COMPACT = {
  SIZE: 18,
  COLOR: LANDING_SITE_NAV_SIGN_OUT_ICON.COLOR,
} as const

/** Below this viewport width (web), org-style header uses a stacked two-row layout. */
export const LANDING_SITE_NAV_COMPACT_BREAKPOINT_WIDTH = 720
